import React from 'react';
import { motion } from 'framer-motion';
export function ManifestoSection() {
  return <section id="manifesto" className="py-24 md:py-32 relative bg-obsidian overflow-hidden" data-id="element-76">
      {/* Decorative Rose Divider Top */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-xs flex justify-center opacity-30" data-id="element-77">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-crimson" data-id="element-78">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" data-id="element-79" />
        </svg>
      </div>

      <div className="max-w-3xl mx-auto px-6 text-center relative z-10" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-81">
          <h2 className="font-heading text-3xl md:text-4xl text-amber-dim mb-8 tracking-widest uppercase" data-id="element-82">
            Our Manifesto
          </h2>

          <div className="space-y-6 font-body text-xl md:text-2xl text-bone/90 leading-loose italic" data-id="element-83">
            <p data-id="element-84">
              "The dark arts of storytelling have wandered without a home for
              too long. Scattered across platforms that neither understand nor
              celebrate the beauty of shadow, gothic creators deserve a realm of
              their own."
            </p>
            <p className="text-parchment" data-id="element-85">
              "Ravenhold was forged in candlelight — a covenant between those
              who find wonder in the dark."
            </p>
          </div>

          <div className="mt-12 flex justify-center" data-id="element-86">
            <div className="w-16 h-1 bg-crimson/30 rounded-full" data-id="element-87" />
          </div>
        </motion.div>
      </div>

      {/* Background Texture */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-charcoal/20 to-transparent pointer-events-none" data-id="element-88" />
      <div className="absolute bottom-0 left-0 w-1/3 h-full bg-gradient-to-r from-charcoal/20 to-transparent pointer-events-none" data-id="element-89" />
    </section>;
}